module.exports = __webpack_public_path__ + "img/w3_question_light.c28dc0e7.png";